import { render, staticRenderFns } from "./title_x.vue?vue&type=template&id=3ab167de&scoped=true&"
import script from "./title_x.vue?vue&type=script&lang=js&"
export * from "./title_x.vue?vue&type=script&lang=js&"
import style0 from "./title_x.vue?vue&type=style&index=0&id=3ab167de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab167de",
  null
  
)

export default component.exports